var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreySpinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5.92389L4.32196 6.97594C4.69598 6.32634 5.15529 5.73141 5.69335 5.19336C6.48513 4.40158 7.40595 3.78041 8.43176 3.34734C9.49256 2.89896 10.619 2.67148 11.7826 2.67148C12.9462 2.67148 14.0748 2.89896 15.1334 3.34734C16.1592 3.78041 17.0801 4.40158 17.8718 5.19336C18.6636 5.98513 19.2848 6.90595 19.7178 7.93176C20.1684 8.99038 20.3959 10.119 20.3959 11.2826C20.3959 12.4462 20.1684 13.5748 19.72 14.6334C19.287 15.6592 18.6658 16.5801 17.874 17.3718C17.0822 18.1636 16.1614 18.7848 15.1356 19.2178C14.0748 19.6662 12.9484 19.8937 11.7848 19.8937C11.0346 19.8937 10.2931 19.7975 9.57568 19.6094C8.88233 19.4256 8.21085 19.1544 7.58311 18.8023C6.34514 18.1089 5.28434 17.1094 4.521 15.9108C4.45319 15.8036 4.38758 15.6964 4.32415 15.5871L2.5 16.6413C2.57874 16.7791 2.66185 16.9125 2.74497 17.0459C4.65004 20.0249 7.98556 22 11.7826 22C17.7012 22 22.5 17.2012 22.5 11.2826C22.5 5.36396 17.7012 0.565186 11.7826 0.565186C7.81715 0.565186 4.35258 2.7196 2.5 5.92389Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreySpinIcon);
export default __webpack_public_path__ + "static/media/greySpinIcon.7e17184331769e2a5cd8dba423cb5ed4.svg";
export { ForwardRef as ReactComponent };